import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ContentLayout } from '../../_NEXT_components/ContentLayout';
import { isValidCode } from '../../utils/validation';
import { ConfirmationSmsCodeForm } from '../../_NEXT_components/ConfirmationSmsCodeForm';
import { ESendValidationCodeStatus } from '../../types/phoneAuth';
import { trackPhoneAuthResendValidationCode } from '../../utils/tracking';
export function PhoneAuthValidateSmsFormContainer(_ref) {
  var sendValidationCodeStatus = _ref.sendValidationCodeStatus,
      isSubmitting = _ref.isSubmitting,
      hasCodeError = _ref.hasCodeError,
      codeError = _ref.codeError,
      resendTimeout = _ref.resendTimeout,
      registerOrAuthorize = _ref.registerOrAuthorize,
      sendValidationCode = _ref.sendValidationCode;
  var prevSendValidationCodeStatus = React.useRef(sendValidationCodeStatus); // FORM

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      touched = _React$useState2[0],
      setTouched = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      changed = _React$useState4[0],
      setChanged = _React$useState4[1]; // CODE


  var codeRef = React.useRef(null);

  var _React$useState5 = React.useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      code = _React$useState6[0],
      setCode = _React$useState6[1];

  var isCodeInvalid = React.useMemo(function () {
    return code === '' || code !== '' && !isValidCode(code);
  }, [code]);

  var _React$useState7 = React.useState(new Date().getTime()),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      lastAttemptTimestamp = _React$useState8[0],
      setLastAttemptTimestamp = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      resendAvailable = _React$useState10[0],
      setResendAvailable = _React$useState10[1];

  var validateCode = React.useCallback(function (code) {
    if (!isValidCode(code)) {
      if (codeRef.current) {
        codeRef.current.focus();
      }

      return;
    }

    registerOrAuthorize(code);
    setChanged(false);
  }, [registerOrAuthorize]);
  var handleChangeCode = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    var newValue = value.replace(/\D/gi, '');

    if (newValue.length > 4) {
      return;
    }

    setChanged(true);
    setCode(newValue);
    validateCode(newValue);
  }, [validateCode]);
  var handleTimeoutExpired = React.useCallback(function () {
    setResendAvailable(true);
  }, []);
  var handleResendClick = React.useCallback(function (e) {
    e.preventDefault();
    trackPhoneAuthResendValidationCode();

    if (sendValidationCodeStatus !== ESendValidationCodeStatus.Succeed) {
      return;
    }

    sendValidationCode();
    setCode('');

    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, [sendValidationCodeStatus, sendValidationCode]); // FORM

  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    validateCode(code);
  }, [code, validateCode]);
  React.useEffect(function () {
    if (prevSendValidationCodeStatus.current !== sendValidationCodeStatus) {
      if (sendValidationCodeStatus === ESendValidationCodeStatus.Failed) {
        setLastAttemptTimestamp(null);
      } else if (sendValidationCodeStatus === ESendValidationCodeStatus.Succeed) {
        setLastAttemptTimestamp(new Date().getTime());
      }

      setResendAvailable(false);
    }

    prevSendValidationCodeStatus.current = sendValidationCodeStatus;
  }, [sendValidationCodeStatus]);
  return /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement(ConfirmationSmsCodeForm //FORM
  , {
    isSubmitting: isSubmitting,
    handleSubmit: handleSubmit,
    submitButtonText: "\u0412\u043E\u0439\u0442\u0438" //CODE
    ,
    codeRef: codeRef,
    code: code,
    onCodeChange: handleChangeCode,
    codeError: !changed && codeError || undefined,
    isCodeInvalid: touched && (isCodeInvalid || !changed && hasCodeError),
    resendAvailable: resendAvailable,
    resendTimeout: resendTimeout,
    lastResendTime: lastAttemptTimestamp,
    onResendTimeoutExpired: handleTimeoutExpired,
    onResend: handleResendClick
  }));
}